import React, {useEffect, useRef} from 'react';
import {clearRequiredFieldError, resetRequiredFieldError} from "../../utils/project-utils.js";
import {useRequiredFieldError} from "../../hooks/use-required-field-error.js";

const InputCheckbox = ({className, label, name, disabled, id, onChange, checked, inputRef, title = "", required, requireChecked = false, invalid = false, classNameLabel, invert = false}) => {
    const checkboxRef = useRef(null);
    const isRequired = required || requireChecked || (typeof label === "string" && label.trim().endsWith("*"));
    const labelText = typeof label === "string" ? label.replace(/\s*\*\s*$/, "") : label;
    const requiredFieldInvalid = useRequiredFieldError(checkboxRef, isRequired);
    const hasRequiredError = !disabled && isRequired && !checked && (invalid || requiredFieldInvalid);

    useEffect(() => {
        if (isRequired && checked) clearRequiredFieldError(checkboxRef.current);
    }, [checked]);

    useEffect(() => {
        if (disabled) resetRequiredFieldError(checkboxRef.current);
    }, [disabled]);

    const setCheckboxRef = (element) => {
        checkboxRef.current = element;

        if (typeof inputRef === "function") inputRef(element);
        else if (inputRef) inputRef.current = element;
    };

    return (
        <div className={["flex items-start text-gray-500", className].join(" ")} title={title}>
            { label && invert === true &&
                <label htmlFor={id} className={["pr-2 ms-2 text-[13px] transform -translate-y-[1px]", classNameLabel, disabled ? 'text-gray-400' : 'cursor-pointer'].join(" ")}>
                    {labelText}{isRequired ? <span className="ml-0.5">*</span> : null}
                </label>
            }

            <input
                ref={setCheckboxRef}
                id={id}
                name={name}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                required={requireChecked}
                data-required-field={isRequired || undefined}
                data-required-checked={requireChecked || undefined}
                aria-invalid={hasRequiredError}
                onChange={onChange}
                className={["w-4 h-4 bg-gray-100 border-gray-300 rounded-md transition-[border-color,border-width] duration-150 ease-out", disabled ? 'opacity-70' : 'cursor-pointer', hasRequiredError ? "!border-[2px] !border-[#dc2626]" : ""].join(" ")}
            />

            { label && invert === false &&
                <label htmlFor={id} className={["ms-2 text-[13px] transform -translate-y-[1px]", classNameLabel, disabled ? 'text-gray-400' : 'cursor-pointer'].join(" ")}>
                    {labelText}{isRequired ? <span className="ml-0.5">*</span> : null}
                </label>
            }
        </div>
    );
};

export default InputCheckbox;